import http from '@/plugins/http';
import { useAuthStore } from '@/stores/auth';
import reportError from '@/utils/reportError';
import accountService from '../account';

// When the request succeeds
const success = (token, onFailureCallback, onSuccessCallback) => {
  useAuthStore().login(token);
  accountService.find(onFailureCallback, onSuccessCallback);
};

// When the request fails
const failed = (error, onFailureCallback) => {
  onFailureCallback(error);
};

export default (user, onFailureCallback, onSuccessCallback) => {
  if (!user.email || !user.password) {
    failed('user or password not set', onFailureCallback);
  } else {
    const data = {
      username: user.email,
      password: user.password,
      client_id: '1_3vphdvfsk0sggg8k8ockc0gcw4s040gowocko8gk4s8sok8gc',
      client_secret: 'xdpwhf9uon4ws8g4ss40gcsokk4wwws800sk8kgsowkkcs8o4',
      grant_type: 'password',
    };
    http.post('/oauth/v2/token', data)
      .then((response) => {
        success(response.data.access_token, onFailureCallback, onSuccessCallback);
      })
      .catch((error) => {
        reportError(error, 'error when trying to login');
        failed(error, onFailureCallback);
      });
  }
};
